import React from 'react'
import { Menu } from 'antd'
import { withRouter } from 'react-router-dom'
// nikhil : this is not wotk bcoz antd didn't suport inner compo

const MenuItem = ({ id, display, prefix }) => (
  <Menu.Item
    style={{ marginLeft: '20px', marginTop: '10px' }}
    exact
    key={`${prefix}/${id}`}
  >
    {display}
  </Menu.Item>
)
// --key={`${prefix}-${id}`}

export default withRouter(MenuItem)
